import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConsultaSolicitudesDisponiblesDTO } from 'src/app/infraestructure/interfaces/referente/ConsultaSolicitudesDisponiblesDTO';

@Component({
  selector: 'app-table-consult-request',
  templateUrl: './table-consult-request.component.html',
  styleUrls: ['./table-consult-request.component.scss']
})
export class TableConsultRequestComponent implements OnInit {

  @Output() getSolicitudById = new EventEmitter<number>();
  @Output() idSolicitudSeleccionada = new EventEmitter<number>();
  @Output() actionCancel = new EventEmitter<boolean>();
  @Output() solicitudSeleccionada = new EventEmitter<ConsultaSolicitudesDisponiblesDTO>();

  @Input() dataTable: ConsultaSolicitudesDisponiblesDTO[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  selectSolicitud(id: number) {
    this.getSolicitudById.emit(id);
  }

  onCancel(cancel: any, data: ConsultaSolicitudesDisponiblesDTO) {
    this.idSolicitudSeleccionada.emit(Number(data.id));
    this.solicitudSeleccionada.emit(data);
    this.actionCancel.emit(cancel);
  }
}
